module.exports = __webpack_public_path__ + "img/gear.svg";